import React from 'react';

const styles = {
  cellStyle: {
    width: '150px',
  },
  letterStyle: {
    fontSize: '2em',
    lineHeight: '1em',
    fontWeight: 'bold',
  },
  buttonStyle: {
    fontSize: '1.5em',
    fontWeight: 'bold',
    height: '30px',
    width: '30px',
  },
};

// eslint-disable-next-line @typescript-eslint/no-empty-function
function LetterCell({ cellId, content = null, grid, onClick = () => {} }) {
  const handleClick = () => onClick(cellId);
  return (
    <div
      className="d-flex flex-column flex-create justify-content-center align-items-center pb-4"
      id={cellId}
      style={{ ...styles.cellStyle }}
    >
      <div className="d-flex flex-row pb-2" style={{ ...styles.letterStyle }} onClick={handleClick}>
        {grid[cellId]}
      </div>
      <div
        className="d-flex flex-row circle-with-text"
        style={{ ...styles.buttonStyle, backgroundColor: content[cellId] ? '#5cbfe6' : 'transparent' }}
      >
        {content[cellId]}
      </div>
    </div>
  );
}

export default LetterCell;
